jQuery(document).ready(function ($) {
    $(document).on('click', '.dnJs-pastInputValueFromInput', function (e) {
        e.preventDefault();
        $('[data-pastInputValueFromInputId]').each(function () {
            var inputFieldTo = $(this);
            var InputFieldFrom = $('input#' + inputFieldTo.attr('data-pastInputValueFromInputId'));
            inputFieldTo.val(InputFieldFrom.val());
        });
    });
});